import { render } from "./MarketDefinitionSelection.vue?vue&type=template&id=521d1244&scoped=true"
import script from "./MarketDefinitionSelection.vue?vue&type=script&lang=js"
export * from "./MarketDefinitionSelection.vue?vue&type=script&lang=js"

import "./MarketDefinitionSelection.vue?vue&type=style&index=0&id=521d1244&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521d1244"],['__file',"src/components/pattern/MarketDefinitionSelection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "521d1244"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('521d1244', __exports__)) {
    api.reload('521d1244', __exports__)
  }
  
  module.hot.accept("./MarketDefinitionSelection.vue?vue&type=template&id=521d1244&scoped=true", () => {
    api.rerender('521d1244', render)
  })

}


export default __exports__